import type { ReactNode } from 'react';
import React, { useMemo } from 'react';
import type { Store } from 'react-redux';
import { Provider as ReduxProvider } from 'react-redux';
import { B2CAppContextProvider } from 'Context/ReactAppContext';
import { PageContextProvider } from 'Context/PageContext';
import { ToastContext } from 'Context/ToastContext';
import { ResponsiveLayout } from 'Components/utils/responsive/ResponsiveLayout';
import DepartureCitiesProvider from 'Context/DepartureCitiesProvider';
import { ResortListProvider } from 'Context/ResortListProvider';
import FavoriteProductListProvider from 'Context/FavoriteProductListProvider';
import AbTestProvider, { useMockABTasty } from 'Context/ABTestProvider';
import { OptinsProvider } from 'Context/OptinsProvider';
type Props = {
  children: ReactNode;
  appContext: AppContext;
  pageContext: PageContext;
  reduxStore: Store<ReduxState>;
  toastRef?: {
    current: HTMLElement | null | undefined;
  };
};
export const AppProviders = ({
  children,
  appContext,
  pageContext,
  reduxStore,
  toastRef,
}: Props) => {
  const toastValue = useMemo(
    () => ({
      ref: toastRef,
    }),
    [toastRef],
  );
  // Mock ABTasty for testing purposes in local development
  useMockABTasty();
  return (
    <B2CAppContextProvider appContext={appContext}>
      <PageContextProvider pageContext={pageContext}>
        <ReduxProvider store={reduxStore}>
          <AbTestProvider>
            <ResponsiveLayout userAgent={appContext.userAgent} device={appContext.device}>
              <DepartureCitiesProvider>
                <ResortListProvider>
                  <FavoriteProductListProvider>
                    <ToastContext.Provider value={toastValue}>
                      <OptinsProvider>{children}</OptinsProvider>
                    </ToastContext.Provider>
                  </FavoriteProductListProvider>
                </ResortListProvider>
              </DepartureCitiesProvider>
            </ResponsiveLayout>
          </AbTestProvider>
        </ReduxProvider>
      </PageContextProvider>
    </B2CAppContextProvider>
  );
};
